var _path, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.218,
    height: 74.989,
    viewBox: "0 0 263.218 74.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M206.854,239.969,168.982,218.88l-38.832,20.9.362,34.889,35.081,19.2.139-.33V278.726l-22.826-12.5-.181-18.041L168.886,234.1l25.49,14.194v6.639l-28.836-.213v13.608l41.315.3Z",
    transform: "translate(-57.8 -218.88)",
    fill: "#f98b88"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "MY",
    transform: "translate(0 48.006)",
    fill: "#9a82b8",
    fontSize: 36,
    fontFamily: "Trenda-Bold, Trenda",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MY"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "STATE",
    transform: "translate(154.218 48.006)",
    fill: "#9a82b8",
    fontSize: 36,
    fontFamily: "Trenda-Bold, Trenda",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STATE"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.7eccaa4745971a0e13de5a19477c7f57.svg";
export { ForwardRef as ReactComponent };